// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"283":"4ff0177d","315":"18a1e437","923":"2fb71813"}[chunkId] + ".chunk.js";
};